import { FC, memo } from "react";

const SortAndFilter: FC = () => {
  return (
    <>
      <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.1322 8.07502C13.6518 9.56628 15.0703 10.6364 16.7387 10.6364C18.4071 10.6364 19.8255 9.56628 20.3452 8.07502H22.3625C22.9907 8.07502 23.5 7.56574 23.5 6.93752C23.5 6.30929 22.9907 5.80002 22.3625 5.80002H20.4196C19.974 4.18559 18.4948 3 16.7387 3C14.9825 3 13.5033 4.18559 13.0577 5.80002H3.63754C3.00932 5.80002 2.50004 6.30929 2.50004 6.93752C2.50004 7.56574 3.00932 8.07502 3.63754 8.07502H13.1322ZM14.8296 6.81807C14.8296 7.87243 15.6844 8.72716 16.7387 8.72716C17.7931 8.72716 18.6478 7.87243 18.6478 6.81807C18.6478 5.7637 17.7931 4.90897 16.7387 4.90897C15.6844 4.90897 14.8296 5.7637 14.8296 6.81807ZM3.6375 18.75C3.00928 18.75 2.5 18.2407 2.5 17.6125C2.5 16.9843 3.00928 16.475 3.6375 16.475L5.62272 16.475C6.11415 14.9342 7.55728 13.8182 9.26105 13.8182C10.9648 13.8182 12.408 14.9342 12.8994 16.475L22.3625 16.475C22.9907 16.475 23.5 16.9843 23.5 17.6125C23.5 18.2407 22.9907 18.75 22.3625 18.75L12.9143 18.75C12.4377 20.3155 10.9824 21.4546 9.26105 21.4546C7.53971 21.4546 6.08441 20.3155 5.60782 18.75H3.6375ZM9.26111 15.7273C10.3155 15.7273 11.1702 16.582 11.1702 17.6364C11.1702 18.6908 10.3155 19.5455 9.26111 19.5455C8.20675 19.5455 7.35202 18.6908 7.35202 17.6364C7.35202 16.582 8.20675 15.7273 9.26111 15.7273Z"
          fill="#167E76"
        />
      </svg>
    </>
  );
};

export default memo(SortAndFilter);
